function chipsBottomAction() { }
function defaultValueGetter() {
    return {};
}
function onBlur(e) {
    console.log(e);
}
function onChange(e) {
    console.log(e);
}
function onClose(value) {
    console.log(value);
}
function onKeyPress(e) {
    console.log(e);
}
export var CustomInputType;
(function (CustomInputType) {
    CustomInputType["Checkbox"] = "checkbox";
    CustomInputType["CheckboxArray"] = "checkboxArray";
    CustomInputType["Chips"] = "chips";
    CustomInputType["Email"] = "email";
    CustomInputType["File"] = "file";
    CustomInputType["Text"] = "text";
    CustomInputType["Select"] = "select";
    CustomInputType["Multiline"] = "multiline";
    CustomInputType["Number"] = "email";
    CustomInputType["Password"] = "password";
    CustomInputType["Phone"] = "phone";
    CustomInputType["Radio"] = "radio";
    CustomInputType["Editor"] = "editor";
    CustomInputType["Switch"] = "switch";
})(CustomInputType || (CustomInputType = {}));
export var CustomInputValidationType;
(function (CustomInputValidationType) {
    CustomInputValidationType["IsArray"] = "isArray";
    CustomInputValidationType["IsInteger"] = "isInteger";
    CustomInputValidationType["IsNumber"] = "isNumber";
    CustomInputValidationType["Max"] = "max";
    CustomInputValidationType["MaxLength"] = "maxLength";
    CustomInputValidationType["Min"] = "min";
    CustomInputValidationType["MinLength"] = "minLength";
    CustomInputValidationType["Required"] = "required";
})(CustomInputValidationType || (CustomInputValidationType = {}));
//# sourceMappingURL=customInput.model.js.map